import ToggleGroup from "./ToggleGroup"
import ToggleGroupItem from "./ToggleGroupItem"

export type { ToggleGroupProps } from "./ToggleGroup"
export type { ToggleGroupItemProps } from "./ToggleGroupItem"

export default Object.assign(ToggleGroup, {
  Item: ToggleGroupItem,
})
